import React from 'react';

const HorryCountyLogo: React.FC = () => {
  return (
    <a className="logo" href="https://www.horrycountysc.gov">
      <img
        src= "https://www.horrycountysc.gov/documents/icon"
        alt="Horry County Government logo"
        id="hcglogo"
      />
    </a>
  )
}

export default HorryCountyLogo;